// firebaseConfig.js
import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDmaTwo2jXH_nxFZM5f_jmXSHrVlY_z67o",
  authDomain: "satellitechat-e02bd.firebaseapp.com",
  projectId: "satellitechat-e02bd",
  storageBucket: "satellitechat-e02bd.firebasestorage.app",
  messagingSenderId: "294025920418",
  appId: "1:294025920418:web:ba68fe18390df7bd807cfb",
  measurementId: "G-NBEGCDK9CM",
};

const app = initializeApp(firebaseConfig);

// Conditionally initialize Analytics
let analytics;
if (process.env.NODE_ENV === "production") {
  analytics = getAnalytics(app);
}

const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error("Error setting persistence:", error);
});

const googleProvider = new GoogleAuthProvider();
const db = getFirestore(app);
const functions = getFunctions(app, "us-central1");
const storage = getStorage(app);

export { auth, googleProvider, db, functions, storage, analytics };